// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.accounts.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/accounts/account/account.tpl.html',
            controller: 'AccountController as vm'
        }},
        resolve: {
            account: function() { return {}; },
            isNewAccount: function() {return true;}
        }
    });

    $stateProvider.state('base.accounts.account', {
        url:'/{accountId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/accounts/account/account.tpl.html',
            controller: 'AccountController as vm'
        }},
        resolve: {
            account: accountResolver,
            isNewAccount: function() {return false;}
        }
    });

}

// @ngInject
function accountResolver($stateParams, AccountsApiService) {
    return AccountsApiService.getAccount($stateParams.accountId);
}

// @ngInject
function languagesResolver($stateParams, AccountsApiService) {
    return AccountsApiService.getLanguages();
}

// @ngInject
function AccountController($state, account, loadSpinnerService, AccountsApiService, ToasterService, confirmationDialogService, $translate, isNewAccount) {
    var vm = this;

    var accountCopy = {};

    vm.account = account;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveAccount = saveAccount;
    vm.deleteAccount = deleteAccount;

    vm.isNewAccount = isNewAccount;
    vm.isEditing = vm.isNewAccount;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactAccountView') === 'true';
    vm.reactAccountId = isNewAccount ? null : (account && account.id != null ? account.id : null);

    vm.isAccountNumberValid = isAccountNumberValid;
    vm.isAllInformationValid = isAllInformationValid;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewAccount) {
            vm.account = {};
        }

        appendLocalizations(vm.account, vm.languages);

    }

    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function enableEditing() {
        accountCopy = angular.copy(vm.account);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.account = accountCopy;
        vm.isEditing = false;
    }

    function saveAccount() {
        if (vm.isNewAccount) {
            saveNewAccount();
        } else {
            updateAccount();
        }
    }

    function saveNewAccount() {
        loadSpinnerService.start('mainSpinner');
        AccountsApiService.createAccount(vm.account).then(function(response) {
            vm.account = response;
            prepareData();
            vm.isNewAccount = false;
            vm.isEditing = false;
            $state.go('base.accounts.account', {accountId: vm.account.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateAccount() {
        loadSpinnerService.start('mainSpinner');

        AccountsApiService.updateAccount(vm.account).then(function(response) {
            vm.account = response;
            prepareData();
            vm.isNewAccount = false;
            vm.isEditing = false;
            $state.go('base.accounts.account', {accountId: vm.account.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteAccount() {
        confirmationDialogService
            .showDialog($translate.instant('account.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    AccountsApiService.deleteAccount(vm.account.id).then(function(response) {
                        vm.account = response;
                        prepareData();
                        vm.isNewAccount = false;
                        vm.isEditing = false;
                        $state.go('base.accounts');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(account) {
        account.showEditForm = !account.showEditForm;
    }

    function prepareData() {
        if (vm.account === undefined) {
            return;
        }

        vm.accountCopy = angular.copy(vm.account);
    }

    function isAllInformationValid() {
        return isAccountNumberValid();
    }

    function isAccountNumberValid() {
        if (!vm.account.accountNumber) { return false; }
        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('accounts.account', [])
    .config(stateConfig)
    .controller('AccountController', AccountController);
